import { Routes, Route, Navigate } from "react-router-dom";
import { useEffect } from "react";
import "./App.scss";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useSelector } from 'react-redux';
import { selectUser } from "./slice/authSlice";
import publicRoutes from "./routes/publicRoutes";
import userRoutes from "./routes/userRoutes";
import providerRoutes from "./routes/providerRoutes";
import NotFound from "./components/NotFound/NotFound";

import subscriptionRoutes from "./routes/subscriptionRoutes";
import ScrollToTop from "./components/scrollTop/ScrollToTop";

import commonRoutes from "./routes/commonRoutes";
import socket from "./socket/socket";
import marketingSubsRoutes from "./routes/marketingSubRoutes";
import AutoLogout from "./AutoLogout";


function App() {

  const user = useSelector(selectUser);
  let roles = user?.userType;
  let routes = [...publicRoutes, ...commonRoutes];
  if (roles !== undefined) {
    switch (roles) {
      case 'user':
        routes = [...publicRoutes, ...userRoutes, ...commonRoutes];
        break;
      case 'provider':

       routes = user?.marketingEmail !== null ? user?.isSubscribedForMarketing ? [...commonRoutes, ...providerRoutes, ...marketingSubsRoutes] : [...commonRoutes, ...marketingSubsRoutes] : [...commonRoutes, ...providerRoutes, ...subscriptionRoutes];
        break;
      default:
        routes = [...publicRoutes, ...commonRoutes];
    }
  }


  const handleHomeRoute = () =>{
    if(user){
      if(roles === 'user'){
        return '/'
      }else if (roles === 'provider'){

        if((user?.marketingEmail && user?.isSubscribedForMarketing) || (user?.marketingEmail === null && user?.isSubscribed)){
          return '/provider/dashboard'
        }else{
          return '/marketingSubs'
        }
      }
    } else{
      return '/'
    }
  }


  useEffect(() => {
    if(user){
      socket.emit("login", { _id: user?.id })
    }
  }, []);

  return (
    <>

    <ScrollToTop />
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        {user && <AutoLogout />}
        <Routes>
          {
            routes.map((route, idx) => {
              return (
                <Route
                exact={route.exact ? true : false}
                key={idx}
                path={route.path}
                element={
                  <route.layout>
                      {route.component}
                    </route.layout>
                  }
                />
              );
            })
          }
          <Route path='/' element={<Navigate to={handleHomeRoute()} />} />
          <Route path='/provider/dashboard' element={<Navigate to={handleHomeRoute()} />} />
          <Route path='*' element={<NotFound />} />
        </Routes>


        </GoogleOAuthProvider>
    </>
  );
}

export default App;
